import { render, staticRenderFns } from "./ProjectTree.vue?vue&type=template&id=6975dc7f&scoped=true"
import script from "./ProjectTree.vue?vue&type=script&lang=js"
export * from "./ProjectTree.vue?vue&type=script&lang=js"
import style0 from "./ProjectTree.vue?vue&type=style&index=0&id=6975dc7f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6975dc7f",
  null
  
)

export default component.exports